/** 用户角色常量 */
export const USER_ROLE_NORMAL = 0;
export const USER_ROLE_ADMIN = 1;
export const USER_ROLE_TEST = 2;

/** 角色标识（用于管理后台表单） */
export const ROLE_KEY_USER = 'user';
export const ROLE_KEY_ADMIN = 'admin';
export const ROLE_KEY_TEST = 'test';

/**
 * 是否可使用开发者工具（开发模式、元素选择、Eruda）
 * @param {number|null|undefined} userRole
 * @returns {boolean}
 */
export function hasDevToolsAccess(userRole) {
  return userRole === USER_ROLE_ADMIN || userRole === USER_ROLE_TEST;
}

/**
 * 将数据库角色值转为表单角色标识
 * @param {number|null|undefined} userRole
 * @returns {string}
 */
export function userRoleToRoleKey(userRole) {
  if (userRole === USER_ROLE_ADMIN) return ROLE_KEY_ADMIN;
  if (userRole === USER_ROLE_TEST) return ROLE_KEY_TEST;
  return ROLE_KEY_USER;
}

/**
 * 将表单角色标识转为数据库角色值
 * @param {string} roleKey
 * @returns {number}
 */
export function roleKeyToUserRole(roleKey) {
  if (roleKey === ROLE_KEY_ADMIN) return USER_ROLE_ADMIN;
  if (roleKey === ROLE_KEY_TEST) return USER_ROLE_TEST;
  return USER_ROLE_NORMAL;
}

/**
 * 获取角色显示名称
 * @param {number|null|undefined} userRole
 * @returns {string}
 */
export function getUserRoleLabel(userRole) {
  if (userRole === USER_ROLE_ADMIN) return '管理员';
  if (userRole === USER_ROLE_TEST) return '测试账号';
  return '普通用户';
}
